import { MapDataSource, MapDataSourceId, MapDataSourceType } from "../models/MapDataSource";
import { fetchHasDataYear } from "./fetchHasDataYear";
import { fetchUpdateDataYear } from "./fetchUpdateDataYear";
import { fetchParametersHasData } from "./fetchParametersHasData";
import { getCurrentYear } from "./getCurrentYear";
import { DictionariesService } from "@sa/rep-mdm";

export async function getDefaultYear(dictionariesService: DictionariesService, source: MapDataSource,  /*parameters: Parameters*/) {
  let defaultYear = await fetchHasDataYear(dictionariesService, source);
  if (!defaultYear) {
    defaultYear = getCurrentYear();
    switch (source.id) {
      case MapDataSourceId.HarmonizedDataset: {
        const year = await fetchHasDataYear(dictionariesService, source);
        if (year) {
          defaultYear = year;
        }
        break;
      }
      case MapDataSourceId.FAPRI2012: {
        defaultYear = 120120101;
        break;
      }
      default: {
        if (source.type === MapDataSourceType.Forecast) {
          const year = await fetchUpdateDataYear(source);
          if (year) {
            defaultYear = year;
          }
        } else if (source.type === MapDataSourceType.Historical) {
          const lastDataYear = await fetchHasDataYear(dictionariesService, source);
          if (lastDataYear) {
            defaultYear = lastDataYear;
          }
        }
        break;
      }
    }
  }
  return defaultYear;
}